import GooglePlayBadge from 'assets/google-play-store-badge.svg';
import AppleStoreBadge from 'assets/apple-app-store-badge.svg';
import { useIntl } from '@leagueplatform/locales';
import { EXTERNAL_LINKS, INTERNAL_LINKS } from 'common/links';
import {
  AssetLinkProps,
  FooterLinkProps,
} from '@leagueplatform/solutions-foundation';

export const useAppFooterLinks = () => {
  const { formatMessage } = useIntl();

  const footerLinks: FooterLinkProps[] = [
    {
      text: formatMessage({ id: 'STR_ABOUT' }),
      url: INTERNAL_LINKS.ABOUT,
    },
    {
      text: formatMessage({ id: 'STR_CONTACT_US' }),
      url: INTERNAL_LINKS.CONTACT_US,
    },
    {
      text: formatMessage({ id: 'STR_TERMS' }),
      url: INTERNAL_LINKS.TERMS,
    },
    {
      text: formatMessage({ id: 'STR_POLICY' }),
      url: INTERNAL_LINKS.POLICY,
    },
  ];

  const appDownloadLinks: AssetLinkProps[] = [
    {
      src: AppleStoreBadge,
      url: EXTERNAL_LINKS.APPLE_STORE_APP,
      alt: formatMessage({ id: 'STR_DOWNLOAD_APP_STORE' }),
    },
    {
      src: GooglePlayBadge,
      url: EXTERNAL_LINKS.GOOGLE_PLAY_STORE_APP,
      alt: formatMessage({ id: 'STR_DOWNLOAD_GOOGLE_PLAY' }),
    },
  ];

  return {
    footerLinks,
    appDownloadLinks,
  };
};
